export const ROLE_PERMISSIONS_TOOLTIP = 
'Select "End-User" for Franchise Owners or Staff.<br>' + 
'For Corporate users, select "Admin," "Manager," or "Member."<br>' +
'See Roles & Permissions in Settings for details.';

export const SECURITY_LABELS_TOOLTIP = 'For more than one Label,<br>' +
'separate with a comma';

export const FEEDBACK_MODAL_TEXT = "We value your thoughts. Please ask a question, leave a comment, report a bug, or suggest an improvement below and click Submit."

export const TRAINING_NOTE = 
  '<strong>IMPORTANT NOTE:</strong> Please carefully edit the query or response to train the AI Support Agent. ' +
  'The text you provide will be used verbatim for similar user queries in the future. ' +
  'Make sure to include any relevant links and avoid mentioning specific individuals (e.g., "Hi John") ' +
  'unless absolutely necessary for the response. Be thorough to ensure that the response is accurate and appropriate.';


export const ORG_SWITCH_MODAL_TEXT = "Switch Organization context to view interactions and trainings from other organizations"

export const CONTENT_GAP_HELP_TEXT = `
Our system automatically analyzes patterns in user queries where the AI was unable \
to provide an answer. Based on this analysis, the AI generates Content Recommendations, \
organized by department, to help you identify gaps and strengthen your knowledge \
base.

**How It Works**
- When the AI encounters unresolved or incomplete queries, it generates a recommendation \
  for review, sorted by department.
- Each recommendation is assigned a "**Needs Attention**" status.

**Actions**
When reviewing recommendations, you can take one of two actions by changing the status:

**1. "Inform Department"**
_Action_: The relevant department team members will be notified of the recommendation \
so that they can create or update the required content.

**2. "Not Applicable"**
_Action_: Use this when the AI's inability to respond is justified (e.g., support \
requires human intervention). The recommendation will be removed from the list, \
and the AI will automatically learn not to suggest this item again.

**Automated Resolutions & Updates**
- **Weekly Review**: Every weekend, the AI re-evaluates previously unresolved \
  interactions. If new data now provides an answer, those recommendations are \
  automatically marked as "**Resolved**".
- **Monthly Refresh**: New content recommendations are published on the **first \
  Monday of every month**, ensuring teams always have an up-to-date view of content \
  needs.

This feature is in the BETA state — please click the Feedback icon (on the left \
side pane) to share your feedback and thoughts.
`
